var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 16,
    viewBox: "0 0 110 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31353 0.241284C5.526 2.33155 2.73702 4.4436 0.315922 6.78016C-0.0199775 7.10493 -0.182838 7.62695 0.315922 7.93645C4.4994 10.5357 8.07506 13.7212 12.8954 15.6927C14.1314 16.1983 15.2307 14.7859 13.9977 14.2813C9.3445 12.3774 5.8968 9.28891 1.85728 6.78016C1.85728 7.16596 1.85728 7.55066 1.85728 7.93645C4.27838 5.59989 7.06882 3.48783 9.85489 1.39757C10.851 0.65105 9.30815 -0.505238 8.31353 0.241284Z",
    fill: "#030201"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.906207 8.71999C36.7322 8.77666 72.7521 11.4195 108.402 7.05582C109.553 6.91523 109.061 5.34043 107.923 5.47993C72.446 9.8218 36.555 7.14192 0.906207 7.08524C-0.260354 7.08415 -0.259149 8.7189 0.906207 8.71999Z",
    fill: "#030201"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.24c13b69645ad0c26c24c32b85cd7e20.svg";
export { ForwardRef as ReactComponent };